import React from 'react';
import InsideThisBook from "react/views/insideThisBook/InsideThisBook";
import CardContainer from "./CardContainer";
import { getPrimaryIsbn } from 'data/TitleInfoSelector';
import { getBookContents } from "data/InsideThisBookSelector";
import { getJsonData } from "data/DataStore";

const InsideThisBookContainer = (props) => {
	const data = getJsonData();
	const model = getBookContents(data)
	
	return (
		<CardContainer
			cardName={"Inside This Book"}
			cardModel={model}
			component={InsideThisBook}
			loggingId={getPrimaryIsbn(data)}
			{...props}
		/>
	);
}

export default InsideThisBookContainer;



// WEBPACK FOOTER //
// ./src/react/containers/InsideThisBookContainer.jsx